import Petrol_Vehicle_one from "../../../assets/images/Petrol_Vehicle_one.png";
import Petrol_Vehicle_two from "../../../assets/images/Petrol_Vehicle_two.png";
import Petrol_Vehicle_three from "../../../assets/images/Petrol_Vehicle_three.png";
import Petrol_Vehicle_Four from "../../../assets/images/Petrol_Vehicle_Four.png";

import Icon_Point from "../../../assets/png/Icon_Point.png";
const NZPetrolSafety = () => {
    return (
        <div className="bg-white  pt-[60px] pb-[45px]">
            <div className="custom-container px-[30px] text-start mx-auto ">
                <div className="max-w-[1200px]  mx-auto">
                    <div className="kuunari-bold text-[20px] leading-[71px] text-center ">Safety</div>
                    <p className="text-base text-[#666666] leading-6 font-[Montserrat] text-center">
                        <span>
                            The Tuatara 1000 EFI is fitted with 2 x retractable sash type seatbelts as well as a third lap-belt for the middle passenger and a certified rollover protective structure (ROPS). The passenger cabin compartment may also be fitted with a fully enclosed cabin, comprising a glass windscreen (i.e. safety glass) with a wiper and washer, a passenger rear enclosure with window, as well as full length or half doors.
                        </span>
                        <br />
                        {/* <br /> */}
                        {/* <span>
                            Tuatara strongly believes that EV's for farming is a great option and
                            there will be soon a day when electric vehicles in farming will be the
                            norm, rather than the exception.
                        </span> */}
                    </p>

                </div>
            </div>
        </div>
    );
};
export default NZPetrolSafety;
